var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"label":"bezeichnung","filterable":false,"options":_vm.options},on:{"input":_vm.onChange,"search":_vm.onSearch}},[_c('template',{slot:"no-options"},[_vm._v(" "+_vm._s(_vm.$t('placeholder'))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }